import { CreateSupportTicketLink } from '@gonfalon/contact-support/CreateSupportTicketLink';
import { Message } from '@gonfalon/messages/Message';

export const GenericError = () => (
  <section className="u-flex-center u-mt-xl">
    <h1 className="u-fs-xxl">
      <Message id="errors.genericError.heading" />
    </h1>
    <p className="u-fs-l u-mt-m">
      <Message id="errors.genericError.body" />{' '}
      <CreateSupportTicketLink identifierForAnalyticsTracking="ErrorBoundary" />.
    </p>
  </section>
);
